<div class="frame">
    <div #container class="container">
        <div class="innerText">
            checking if player already installed, <br/>please wait ({{waitCount}})
            <div class="innerText2">
                <br/>
                note: if player already installed, launch it manually
            </div>
            <div class="iconAnim">
                <mat-icon *ngIf="waitCount % 2 == 0">hourglass_bottom</mat-icon>
                <mat-icon *ngIf="waitCount % 2 == 1">hourglass_top</mat-icon>
            </div>
        </div>
    </div>
</div>

